import { Reveal, Overline } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

const faqs = [
  { q: "What services does Team-X offer?", a: "We provide end-to-end technology solutions across telecom, industrial and test automation, middleware, enterprise software, EV & energy management, cybersecurity, AI-driven automation, blockchain, cloud, and web & mobile applications — from architecture and engineering to deployment and managed support." },
  { q: "What is your technology expertise?", a: "Our teams work fluently across Artificial Intelligence, Cloud Computing, Blockchain, IoT, Automation, Cybersecurity, Telecom Networks, and Enterprise Platforms, applying them pragmatically to real business problems." },
  { q: "How do engagement models work?", a: "We offer three flexible models — Consulting Engagements, Custom Solutions, and Managed Services. Each is scoped to your goals and priced custom. We start with a consultation to understand your needs and propose the right structure." },
  { q: "Do you build custom software?", a: "Yes. We design and build custom enterprise applications, digital platforms, and mobile solutions tailored to your workflows, with full integration into your existing systems." },
  { q: "What AI automation capabilities do you provide?", a: "We build AI agents, intelligent process automation, and machine learning solutions — automating complex workflows, augmenting teams, and unlocking insight from your data in a secure, enterprise-ready way." },
];

export const FAQ = () => (
  <section id="faq" className="relative z-10 border-t border-white/10 bg-ink-900/40 py-24 md:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-4xl px-6 md:px-12">
      <div className="text-center">
        <Reveal className="flex justify-center"><Overline>FAQ</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mx-auto mt-6 max-w-2xl font-display text-3xl font-bold tracking-tighter text-white sm:text-4xl md:text-5xl">
            Answers to common questions.
          </h2>
        </Reveal>
      </div>

      <Reveal delay={0.1} className="mt-12">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="py-6 text-left font-display text-lg font-medium text-white hover:text-brand hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed text-zinc-400">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
